import { useState, useEffect, useCallback } from 'react';
import { Tour } from '../types';
import { fetchTours } from '../services/tourService';

interface UseToursReturn {
  tours: Tour[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useTours = (limit: number = 10): UseToursReturn => {
  const [tours, setTours] = useState<Tour[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchToursData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const toursData = await fetchTours(limit);
      setTours(toursData);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch tours';
      setError(errorMessage);
      console.error('Error in useTours:', err);
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    fetchToursData();
  }, [limit, fetchToursData]);

  const refetch = () => {
    fetchToursData();
  };

  return {
    tours,
    loading,
    error,
    refetch
  };
};
